import { render, staticRenderFns } from "./top-card.vue?vue&type=template&id=2721d640&scoped=true"
import script from "./top-card.vue?vue&type=script&lang=js"
export * from "./top-card.vue?vue&type=script&lang=js"
import style0 from "./top-card.vue?vue&type=style&index=0&id=2721d640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721d640",
  null
  
)

export default component.exports